"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var MoveSalesForceButton = /** @class */ (function (_super) {
    __extends(MoveSalesForceButton, _super);
    function MoveSalesForceButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MoveSalesForceButton.prototype.moveSalesForce = function () {
        var url = this.makeSalesForceUrl();
        window.open(url, '_blank');
    };
    MoveSalesForceButton.prototype.isSalesForceShow = function () {
        return value_checker_1.default.isPresent(this.salesForceId);
    };
    /**
     * TODO SalesForceUrlを環境変数にしても良いかも。。
     */
    MoveSalesForceButton.prototype.makeSalesForceUrl = function () {
        if (value_checker_1.default.isBlank(this.salesForceId)) {
            return '';
        }
        return this.$customEnv.get('SALES_FORCE_BASE_URL') + "lightning/r/" + this.salesForceType + "/" + this.salesForceId.trim() + "/view";
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], MoveSalesForceButton.prototype, "salesForceId", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], MoveSalesForceButton.prototype, "salesForceType", void 0);
    MoveSalesForceButton = __decorate([
        vue_property_decorator_1.Component
    ], MoveSalesForceButton);
    return MoveSalesForceButton;
}(vue_property_decorator_1.Vue));
exports.default = MoveSalesForceButton;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/MoveSalesForceButton.vue
// module id = BkIK
// module chunks = 1